import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
/**
 * Make API requests
 *
 * @param  {string}  url    - name of the endpoint, ex: 'users', 'login'
 * @param  {string}  method - fetch method: get | post | put | delete
 * @param  {object}  params - Data to send with the request
 * @return {object||bool}   - Object with fetched data or error message, false if not data is found
 */

export const makeAPIRequest = async (url='', method='GET', params=null, headers=false ) => {

    const requestHeaders = {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'Accept':'application/json'
    }

    return await axios({
        method: method,
        url: API_URL + url,
        data: params,
        withCredentials: true, /* For httponly cookies */
        headers: headers ? headers : requestHeaders
    })
    .then(response => {
        if(!response.data) {
            // no data found
            console.log('no data found');
            return {
                result: false,
                status: false,
                message: false
            };
        }

        if(response.data.token_status){
            // at this point there was a problem with the token
            console.log('there was a problem: ', response.data.token_status);
            return {
                result: false,
                status: 'warning',
                message: response.data.token_status
            };
        }

        // everything is OK, return the fetched data
        return {
            result: response.data,
            status: false,
            message: false
        };

    })
    .catch(err => {
        // catch errors and display a message accordingly
        if(err.response){
            console.log('there was an error: ', err.response.data);

            return {
                result: false,
                status: 'error',
                message: err.response.data
                    ? err.response.data
                    : 'Something went wrong. Please try again later'
            };
        }
        // default
        return {
            result: false,
            status: 'error',
            message: 'Something went wrong'
        };

    })
}
